import styled from "styled-components";
import { Typography } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { theme } from "../../utils/globalStyles/colors";
import { fadeIn } from "../../utils/globalStyles/animations";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const Summary = styled(Typography)`
  color: #999999;
  font-size: 12px !important;
  font-weight: 600 !important;
  margin: 4px 0 8px !important;
`;

export const Group = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const DayLabel = styled(Typography)`
  color: #666666;
  font-size: 13px !important;
  font-weight: 700 !important;
  text-transform: capitalize;
  padding-left: 4px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LoadingMore = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 0;
  color: ${theme.colors.base};
`;

export const EndText = styled(Typography)`
  text-align: center;
  color: #bbbbbb;
  font-size: 12px !important;
  padding: 8px 0;
`;

export const Feedback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 16px;
  text-align: center;
  animation: ${fadeIn} 0.3s ease-out both;
`;

export const EmptyIcon = styled(ReceiptLongIcon)`
  color: #d0d0d0;
  font-size: 48px !important;
`;

export const FeedbackText = styled(Typography)`
  color: #999999;
  font-size: 14px !important;
`;

export const FeedbackButton = styled.button`
  border: 1px solid ${theme.colors.base};
  background: none;
  color: ${theme.colors.base};
  border-radius: 999px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;

  &:active {
    transform: scale(0.96);
  }
`;
